import Quill, { Delta } from 'quill';
import { getInstance } from '@/services/animation';
import editorInstance from '@/lib/editor/editor';
export const isTextElement = (element) => {
    return element.classList.contains('userTextClass');
};
export const isStampElement = (element) => {
    return element.classList.contains('stampElem');
};
export const isAnimatedElement = (element) => {
    return element.classList.contains('.animatedElement');
};
export const isBackgroundImageElement = (element) => {
    return element.classList.contains('backgroundImageClass');
};
export const makeElementItemFromElement = (element) => {
    const types = [
        { type: 'text', check: isTextElement },
        { type: 'stamp', check: isStampElement },
        { type: 'background image', check: isBackgroundImageElement }
    ];
    const type = types.find(type => type.check(element))?.type;
    return {
        component: element,
        type
    };
};
export const createImageElement = (src) => {
    const imageDiv = document.createElement('div');
    Object.assign(imageDiv.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        overflow: 'hidden',
        display: 'flex'
        // height: '100%',
        // width: '100%',
    });
    let highestZIndex = 0;
    const stamps = document.querySelectorAll('.stampElem');
    stamps.forEach(stamp => {
        const i = parseInt(stamp.id.replace('stampID', ''));
        if (i > highestZIndex) {
            highestZIndex = i;
        }
    });
    const index = highestZIndex + 1;
    imageDiv.id = 'stampID' + index;
    imageDiv.style.zIndex = index.toString();
    imageDiv.classList.add('stampElem');
    imageDiv.setAttribute('data-amelement', 'stamp');
    const image = document.createElement('img');
    image.src = src;
    image.style.objectFit = 'contain';
    image.style.height = '100%';
    image.classList.add('stampImg', 'stampImg' + index);
    imageDiv.appendChild(image);
    // image.onload = function() {
    //   imageDiv.style.width = image.width + 'px';
    //   imageDiv.style.height = image.height + 'px';
    // };
    return imageDiv;
};
export const createHTMLTextElement = (textContent) => {
    const div = document.createElement('div');
    div.classList.add('userTextClass');
    let highestZIndex = 0;
    const stamps = document.querySelectorAll('.userTextClass');
    stamps.forEach(stamp => {
        const i = parseInt(stamp.id.replace('userTextID', ''));
        if (i > highestZIndex) {
            highestZIndex = i;
        }
    });
    const index = highestZIndex + 1;
    div.id = 'userTextID' + index;
    Object.assign(div.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        display: 'block'
    });
    const innerDiv = document.createElement('div');
    innerDiv.classList.add('dynamic');
    innerDiv.innerHTML = textContent;
    const child = div.appendChild(innerDiv);
    const quill = new Quill(child, { modules: { clipboard: {
                matchers: [
                    [Node.ELEMENT_NODE, function (node, delta) {
                            return new Delta().insert(node?.textContent + '\n');
                        }
                    ]
                ]
            } } });
    child?.addEventListener('click', () => {
        quill.focus();
    });
    quill.on('text-change', (delta, oldDelta, source) => {
        getInstance().templateLoader.textLoader.identifyTextElements();
        editorInstance.history.addHistory('Update Text');
    });
    setTimeout(() => {
        quill.focus();
        quill.setSelection(0, quill.getLength());
    }, 50);
    return div;
};
